import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError } from "redux-form";
import _ from "lodash";
import Title from "../../components/Layout/Title";
import { toastr } from "react-redux-toastr";
import { BeatLoader } from "react-spinners";
import SelectField from "../../components/Fields/SelectField";
import DropdownListField from "../../components/Fields/DropdownListField";
import { FINANCEIRO_ES_LIST_LOAD, FINANCEIRO_ES_LIST_UNLOAD, FINANCEIRO_ES_COMPANIES_LOAD, LOGOUT } from "../../actions/Constants";
import OtherUtils from "../../components/Util/OtherUtils";
import ReactTable from "react-table";
import MaskDate from "../../components/Util/MaskDate";
import XLSX from "xlsx/dist/xlsx.mini.min";
import * as FileSaver from "file-saver";
import SvgIcon from "react-icons-kit";
import { fileExcelO } from "react-icons-kit/fa/fileExcelO";
import { Link } from "react-router";

import api from "../../api/apiUtil";

const TIPOS_RELATORIO = [
  { id: "TotalIntencoesGravamenaoefetivaramcontrato", name: "Intenções Gravame não efetivaram contrato" },
  { id: "TotalIntencoesGravameNaoEmitiramCRV", name: "Intenções Gravame não emitiram CRV" },
  { id: "TotalCessaoDireitoNaoEfetivaramAditivo", name: "Cessão Direito não efetivaram aditivo" },
  { id: "TotalContratosRegistradosNaoCancelados", name: "Contratos registrados não cancelados" },
  { id: "TotalContratosCancelados", name: "Contratos cancelados" },
  { id: "TotalUploadsContratosEfetuadosNaoCancelados", name: "Uploads contratos efetuados não cancelados" },
  { id: "TotalUploadsContratosPendentes", name: "Uploads contratos pendentes" },
  { id: "TotalContratosEntreguesFisicamente", name: "Contratos entregues fisicamente" },
  { id: "TotalContratosPendentesEnvio", name: "Contratos pendentes de envio" },
  { id: "TotalAditivosRegistradosNaoCancelados", name: "Aditivos registrados não cancelados" },
  { id: "TotalAditivosCancelados", name: "Aditivos cancelados" },
  { id: "TotalUploadsAditivosEfetuadosNaoCancelados", name: "Uploads aditivos efetuados não cancelados" },
  { id: "TotalAditivosPendentesEnvio", name: "Aditivos pendentes de envio" },
  { id: "SituacaoDebitoPendenciasFinanceiras", name: "Situação Débito/Pendências Financeiras" },
  { id: "RelatorioCompensacoesFinanceirasContratosCancelados", name: "Compensações Financeiras - Contratos Cancelados" },
  { id: "RelatorioPagamentoDUAsDuplicidade", name: "Pagamento DUAs em Duplicidade" },
  { id: "RelatorioContratoRegistradoPorRegistradora", name: "Contratos por Registradora" },
  { id: "RelatorioContratoCompoemGuiaPagamento", name: "Contratos da guia de pagamento" },
];

const DATE_FIELDS = ["DataContrato", "DataTransacao", "DataCancelamento", "DataRegistroContrato", "DataUpload", "DataEntrega", "DataAditivo", "DataRegistroAditivo", "DataGeracaoDUA", "DataPagto", "DataRegistro"];

function buildColumns(registros) {
  if (!registros || registros.length === 0) return [];
  const keys = Object.keys(registros[0]);
  return keys.map((key) => ({
    Header: key,
    accessor: key,
    className: "align-middle text-center",
    headerClassName: "font-extra-bold",
    Cell: (row) => {
      const val = row.original[key];
      if (val === null || val === undefined) return <div>-</div>;
      if (DATE_FIELDS.includes(key) && typeof val === "string" && val.length >= 10) {
        return <div>{MaskDate.TO_BR(val)}</div>;
      }
      return <div>{String(val)}</div>;
    },
  }));
}

class FinanceiroES extends React.Component {
  constructor() {
    super();
    this.state = {
      pesquisando: false,
      paginaAtual: 1,
      ultimosDados: null,
    };
  }

  componentDidMount() {
    Promise.resolve(api.Financial.filtroPorUf()).then((all) => {
      this.props.onCompaniesLoad(all);
    });
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  buscar(dados, pagina) {
    var props = this.props;
    this.setState({ pesquisando: true });
    toastr.info("Aguarde", "Realizando consulta...", {
      timeOut: 0,
      component: () => {
        return <BeatLoader size={15} margin={2} color={"#58abc3"} loading={true} />;
      },
    });

    var payload = {
      tipoRelatorio: dados.tipoRelatorio,
      cnpjAgenteFinanceiro: dados.agente ? dados.agente.cnpj : dados.cnpjAgenteFinanceiro,
      referencia: dados.mes + "/" + dados.ano,
      numeroPagina: pagina || 1,
      tamanhoPagina: 200,
    };

    Promise.resolve(api.Detrans.relatoriosES(payload))
      .then((res) => {
        this.props.onListLoad(res);
        this.setState({ pesquisando: false, paginaAtual: pagina || 1, ultimosDados: dados });
        toastr.removeByType("info");
        if (!res || !res.registros || res.registros.length === 0) {
          toastr.info("Aviso", "Não foram encontrados resultados para essa pesquisa.");
        }
      })
      .catch(function (resp) {
        toastr.removeByType("info");
        if (resp === "Unauthorized" || resp === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  formSubmit(values) {
    const errors = {};
    if (!values.tipoRelatorio) errors.tipoRelatorio = "Campo obrigatório";
    if (!values.mes) errors.mes = "Campo obrigatório";
    if (!values.ano) errors.ano = "Campo obrigatório";
    if (!values.agente) errors.agente = "Campo obrigatório";
    if (errors && !_.isEmpty(errors)) {
      toastr.error("Erro", "Campos obrigatórios não foram preenchidos.");
      throw new SubmissionError(errors);
    }
    this.buscar(values, 1);
  }

  paginaAnterior() {
    if (this.state.ultimosDados && this.props.pagination && this.props.pagination.hasPreviousPage) {
      this.buscar(this.state.ultimosDados, this.state.paginaAtual - 1);
    }
  }

  proximaPagina() {
    if (this.state.ultimosDados && this.props.pagination && this.props.pagination.hasNextPage) {
      this.buscar(this.state.ultimosDados, this.state.paginaAtual + 1);
    }
  }

  exportToXLSX() {
    var all = this.props.all;
    if (!all || all.length === 0) return;
    var keys = Object.keys(all[0]);
    var headersExcell = [keys];
    var DataExcel = all.map((row) => {
      var obj = {};
      keys.forEach((key) => {
        var val = row[key];
        if (DATE_FIELDS.includes(key) && typeof val === "string" && val.length >= 10) {
          obj[key] = MaskDate.TO_BR(val);
        } else {
          obj[key] = val;
        }
      });
      return obj;
    });
    var ws = XLSX.utils.aoa_to_sheet(headersExcell);
    XLSX.utils.sheet_add_json(ws, DataExcel, { skipHeader: true, origin: "A2" });
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Resultado");
    var wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), "RelatorioES.xlsx");
  }

  render() {
    const { handleSubmit, all, pagination } = this.props;
    const columns = buildColumns(all);

    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} description="Detran Espírito Santo" />
        <div className="content">
          <div className="row">
            <div className="col-lg-12">
              <div className="hpanel">
                <div className="panel-heading">
                  <div className="panel-tools"></div>
                  Relatórios de Gestão ES
                </div>
                <div className="panel-body">
                  <form className="form-horizontal" onSubmit={handleSubmit(this.formSubmit.bind(this))}>
                    <div className="row">
                      <div className="col-lg-4">
                        <Field
                          name="tipoRelatorio"
                          label="Tipo de Relatório"
                          data={TIPOS_RELATORIO}
                          textField="name"
                          valueField="id"
                          component={SelectField}
                          type="text"
                        />
                      </div>
                      <div className="col-lg-4">
                        <Field
                          name="agente"
                          blank={true}
                          required
                          label="Credor"
                          data={this.props.financeiras}
                          credor={true}
                          textField="razaoSocial"
                          valueField="cnpj"
                          component={DropdownListField}
                          type="text"
                        />
                      </div>
                      <div className="col-lg-2">
                        <Field name="mes" label="Mês referência" data={OtherUtils.monthsWithOptSel} textField="label" valueField="value" component={SelectField} type="text" />
                      </div>
                      <div className="col-lg-2">
                        <Field name="ano" label="Ano referência" data={OtherUtils.yearsWithOptSel} textField="label" valueField="value" component={SelectField} type="text" />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12 align-self-end form-group">
                        <button className="btn btn-info" type="submit" disabled={this.state.pesquisando}>
                          {this.state.pesquisando ? "Aguarde..." : "Filtrar"}
                        </button>
                        {all && all.length > 0 && (
                          <Link className="btn btn-default" style={{ marginLeft: "10px" }} onClick={() => this.exportToXLSX()} title="Gerar Excel">
                            <SvgIcon size={20} icon={fileExcelO} /> Exportar Excel
                          </Link>
                        )}
                      </div>
                    </div>
                  </form>

                  {pagination && (
                    <div className="row" style={{ marginBottom: "10px" }}>
                      <div className="col-lg-12">
                        <span>
                          Página {pagination.numeroPagina} de {pagination.totalPaginas} — Total: {pagination.totalRegistros} registros
                        </span>
                        <button className="btn btn-default btn-sm" style={{ marginLeft: "10px" }} onClick={() => this.paginaAnterior()} disabled={!pagination.hasPreviousPage || this.state.pesquisando}>
                          &laquo; Anterior
                        </button>
                        <button className="btn btn-default btn-sm" style={{ marginLeft: "5px" }} onClick={() => this.proximaPagina()} disabled={!pagination.hasNextPage || this.state.pesquisando}>
                          Próxima &raquo;
                        </button>
                      </div>
                    </div>
                  )}

                  {all && all.length > 0 ? (
                    <ReactTable
                      data={all}
                      columns={columns}
                      defaultPageSize={all.length > 20 ? 20 : all.length}
                      className="-striped -highlight"
                      previousText="Anterior"
                      nextText="Próximo"
                      loadingText="Carregando..."
                      noDataText="Nenhum registro encontrado"
                      pageText="Página"
                      ofText="de"
                      rowsText="registros"
                    />
                  ) : (
                    <p>Nenhum registro encontrado.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onListLoad: (payload) => dispatch({ type: FINANCEIRO_ES_LIST_LOAD, payload }),
  onCompaniesLoad: (payload) => dispatch({ type: FINANCEIRO_ES_COMPANIES_LOAD, payload }),
  onUnload: () => dispatch({ type: FINANCEIRO_ES_LIST_UNLOAD }),
  onLogout: () => dispatch({ type: LOGOUT }),
});

const mapStateToProps = (state) => ({
  ...state.financeiroES,
  currentUser: state.common.currentUser,
});

const form = reduxForm({
  form: "FinanceiroESForm",
});

export default connect(mapStateToProps, mapDispatchToProps)(form(FinanceiroES));
